/** Get the base URL for the admin panel. */
export function getAdminBaseUrl() {
  return (process.env.VUE_APP_REACT_ADMIN_URL || 'http://localhost:8083').replace(/\/$/, '')
}

export const MY_PARTNERS_ADMIN_INVITATIONS_PATH = '/my-partners/invitations'

/** Check if the given path is allowed to be opened in the admin panel. */
export function isAllowedOpenAdminPath(pathname, searchParams) {
  return (
    pathname.startsWith('/my-partners/invitation/') ||
    pathname === MY_PARTNERS_ADMIN_INVITATIONS_PATH ||
    (pathname === '/my-partners' && searchParams.get('tab') === 'invitations')
  )
}

/** Parse a relative admin path into a pathname and search params. */
function parseRelativeAdminPath(relativePath) {
  const url = new URL(relativePath, 'http://admin.local')
  return { pathname: url.pathname, searchParams: url.searchParams }
}

/**
 * Normalize openAdmin target from route query.
 * Browsers/email clients sometimes split `?tab=invitations` out of openAdmin.
 */
export function normalizeOpenAdminTarget(adminTarget, routeQuery = {}) {
  const trimmed = (adminTarget || '').trim()
  if (!trimmed) {
    return trimmed
  }

  if (trimmed === '/my-partners' && routeQuery.tab === 'invitations') {
    return MY_PARTNERS_ADMIN_INVITATIONS_PATH
  }

  if (trimmed === '/my-partners?tab=invitations') {
    return MY_PARTNERS_ADMIN_INVITATIONS_PATH
  }

  return trimmed
}

/** Accepts relative admin path or legacy absolute admin URL. */
export function isAllowedOpenAdminTarget(target, routeQuery = {}) {
  const normalized = normalizeOpenAdminTarget(target, routeQuery)
  const trimmed = (normalized || '').trim()
  if (!trimmed) {
    return false
  }

  if (trimmed.startsWith('/')) {
    const { pathname, searchParams } = parseRelativeAdminPath(trimmed)
    return isAllowedOpenAdminPath(pathname, searchParams)
  }

  try {
    const parsed = new URL(trimmed)
    const allowed = new URL(`${getAdminBaseUrl()}/`)
    if (
      parsed.protocol !== allowed.protocol ||
      parsed.hostname !== allowed.hostname ||
      parsed.port !== allowed.port
    ) {
      return false
    }
    return isAllowedOpenAdminPath(parsed.pathname, parsed.searchParams)
  } catch {
    return false
  }
}

/** Resolves bridge target to absolute admin URL for window.open. */
export function resolveOpenAdminTarget(target, routeQuery = {}) {
  const normalized = normalizeOpenAdminTarget(target, routeQuery)
  const trimmed = (normalized || '').trim()
  if (trimmed.startsWith('/')) {
    return `${getAdminBaseUrl()}${trimmed}`
  }
  return trimmed
}
